// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"9b1cc993","27":"08e3f5fd","143":"679d7422","174":"f36d26a1","216":"f6ebe225","272":"f76fd9fa","281":"76a7bf10","310":"500e51a4","432":"8e5a810e","627":"c0a44d29","675":"0f715e32"}[chunkId] + ".chunk.js";
};